var productServiceMixin= {
    data: function () {
        return {
            PRODUCT_BASE: '/api/ProductsApi/'
        }
    },
    methods: {
        getCategoryProducts: function (sortedCategoryProducts) {
            return this.get(this.PRODUCT_BASE, 'GetCategoryProducts', sortedCategoryProducts);
        },
        getProductRelatedProducts: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetProductRelatedProducts', data);
        },
        getPageRelatedProducts: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetPageRelatedProducts', data);
        },
        getRelatedProductsBasket: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetRelatedProductsBasket');
        },
        getSamplesData: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetSamplesData', data);
        },
        getThicknessesForColourApi: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetThicknessesForColour', data);
        },
        getProductColours: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetProductColours', data);
        },
        getProductThicknesses: function (data) {
            return this.get(this.PRODUCT_BASE, 'GetProductThicknesses', data);
        }

    }
}